export default "__VITE_ASSET__wUn9kaID__"